import { Col } from '../../../lib/utils';
import WeekList from './WeekList';
import WeekScheduleTable from './WeekScheduleTable';

const WeeklySchedule = ({
    setIsLoading,
    grid,
    currentDate,
    authorization,
    authObject,
    selectedDay,
    setSelectedDay,
    onClickFloatingButton,
    onClickSchedule,
    onClickRequest,
    onClickEtcOffSchedule,
    onClickNewOpportunity,
    onClickApproveScheduleRequest,
    onClickRejectScheduleRequest,
    scrollY,
    weeklyScheduleList,
    weeklyGridData,
    lengthArr,
}: any) => {
    return (
        <Col style={{ marginTop: 88 }}>
            {/* 주간 달력 상단 날짜 표시 */}
            <WeekList scrollY={scrollY} weeklyScheduleList={weeklyScheduleList} />
            {/* 주간 달력 표 */}
            <WeekScheduleTable
                weeklyScheduleList={weeklyScheduleList}
                weeklyGridData={weeklyGridData}
                lengthArr={lengthArr}
                scrollY={scrollY}
                onClickSchedule={onClickSchedule}
                onClickRequest={onClickRequest}
                onClickEtcOffSchedule={onClickEtcOffSchedule}
                onClickNewOpportunity={onClickNewOpportunity}
                onClickApproveScheduleRequest={onClickApproveScheduleRequest}
                onClickRejectScheduleRequest={onClickRejectScheduleRequest}
            />
        </Col>
    );
};

export default WeeklySchedule;
